<template>
    <a-card>
        <a-row type="flex" justify="start" class="icons-list">
            <a-col :flex="2">
                <a-icon type="ordered-list" />
            </a-col>
            <a-col :flex="3" justify="center">
                <p>Order List</p>
            </a-col> 
        </a-row>
        <br/> 
        <a-row type="flex" justify="start" class="icons-list">
            <a-col :flex="2">
                
            </a-col>
            <a-col :flex="3" justify="center">
                <a-button @click="handleClick" icon="search" class="ml-15">
                    <i class="ni ni-archive-2 mr-5"></i> VIEW ORDERS
				</a-button>
            </a-col>
            
        </a-row>
    </a-card>
</template>

<script>
export default {
    data () {
        return {
            isEnabled : false
        }
    },
    methods : {
        handleClick() {
            this.$emit('viewOrderSearchEvent', {});
        }
    }
}
</script>

<style scoped>
.icons-list >>> .anticon {
  margin-right: 6px;
  font-size: 24px;
}
</style>
